module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "checkboxLabel"
  }, [_c('i', {
    staticClass: "noChooseRom",
    class: {
      'chooseRom': _vm.setQuestionId
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adf09680","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkboxLabel/checkboxLabel.vue
// module id = 1239
// module chunks = 1